"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconLanguage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconLanguage = function SvgIconLanguage(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_30878_16447)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip1_30878_16447)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.00049 8H11.0005M1.00049 4H11.0005M6.00049 11.5C9.03805 11.5 11.5005 9.03757 11.5005 6C11.5005 2.96243 9.03805 0.5 6.00049 0.5C2.96292 0.5 0.500488 2.96243 0.500488 6C0.500488 9.03757 2.96292 11.5 6.00049 11.5ZM6.00049 11.5C7.50049 11.5 8.00049 9 8.00049 6C8.00049 3 7.50049 0.5 6.00049 0.5C4.50049 0.5 4.00049 3 4.00049 6C4.00049 9 4.50049 11.5 6.00049 11.5Z",
    stroke: "currentColor"
  }))), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_30878_16447"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "12",
    height: "12",
    fill: "white",
    transform: "translate(0.000488281)"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip1_30878_16447"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "12",
    height: "12",
    fill: "white",
    transform: "translate(0.000488281)"
  }))));
};

exports.SvgIconLanguage = SvgIconLanguage;